import { CoveoSearchHub } from '@lib/coveo/coveoConstants';
import { InitEngineOptions, createEngineModule } from './createEngineModule';

const { initEngine, engine, resetEngine } = createEngineModule(
  CoveoSearchHub.SEARCH
);

export { engine, initEngine, resetEngine };
export type { InitEngineOptions };
